module.exports = __webpack_public_path__ + "static/media/signout.9b9e5303.png";